import api from "../..";
import { GetReportsParams, ReportType, Report } from "./types";

export const getReports = async ({ type }: GetReportsParams): Promise<Report[]> => {

  const urlMap: Record<ReportType, string> = {
    user: "/reports/user-reports/",
    post: "/reports/post-reports/",
    course: "/reports/course-reports/",
    article: "/reports/article-reports/",
  };

  return await api.get(urlMap[type])
  .then((res) => {
    return res.data.map((item: any) => ({
      id: item.id,
      user: item.user,
      target:
        item.reported_user ??
        item.post ??
        item.course ??
        item.article,
      type,
      created_at: item.created_at,
      updated_at: item.updated_at,
      subject: item.subject,
      description: item.description,
      status: item.status,
    }));
  })
  .catch(() => {return []});

};